import React from "react";
import SuccessWithCinema from "@components/V3/SuccessWithCinema";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const SuccessBookWithCinemaPage = () => {
    
    return (
        <VersionedLayout>
            <SuccessWithCinema />
        </VersionedLayout>
    );
};

export default SuccessBookWithCinemaPage;
